// extracted by mini-css-extract-plugin
module.exports = {"Product":"Product_Product__JzisO"};